/* eslint-disable max-len */
import 'react';
const PreviewImageReduceSvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17 11.75a.75.75 0 01.102 1.493L17 13.25H7a.75.75 0 01-.102-1.493L7 11.75h10z" fill="#F9F9F9" fillRule="nonzero" /></svg>
);
export default PreviewImageReduceSvg;
